// Which root menu items get a slot in the bottom tab bar (the rest is in "More").
// Order = priority; the first three found are used. An event can put its own choice first: MODERN_TABS in .env.
const DEFAULT_TAB_MODULES = ['sessions', 'my_schedule', 'messages', 'speakers', 'networking', 'partners', 'content_pages']
const TAB_MODULES = [...((window.EasyEvent && EasyEvent.modernTabs) || []), ...DEFAULT_TAB_MODULES]

export const TAB_COUNT = 3

export function pickTabs (rootMenu) {
  const enabled = rootMenu.filter(item => item.enabled && item.module !== 'external_link')
  const picked = []

  TAB_MODULES.forEach(module => {
    const item = enabled.find(i => i.module === module && !picked.includes(i))
    if (item && picked.length < TAB_COUNT) picked.push(item)
  })

  enabled.forEach(item => {
    if (picked.length < TAB_COUNT && !picked.includes(item)) picked.push(item)
  })

  return picked
}

// Fallback icons for menu items without one (Material Symbols names).
const MODULE_ICONS = {
  sessions: 'calendar_month',
  my_schedule: 'star',
  messages: 'campaign',
  speakers: 'mic',
  partners: 'handshake',
  networking: 'diversity_3',
  content_pages: 'info',
  node: 'folder_open',
  feedback: 'reviews',
  questions: 'contact_support',
  voting: 'how_to_vote',
  survey: 'checklist',
  quiz: 'quiz',
  chat: 'forum',
  user_gallery: 'photo_library',
  photobooth: 'photo_camera',
  my_profile: 'account_circle',
  activities: 'local_activity',
  meetings: 'groups',
  external_link: 'open_in_new',
}

export function menuIcon (item) {
  return item.icon || MODULE_ICONS[item.module] || 'apps'
}

// Tile color: the menu item's button color from the admin, otherwise a varied palette (tokens).
// all saturated: the event accent can be a muted tone (RAFA: grey-brown), which made its tile look disabled
const TILE_COLORS = ['var(--brand)', 'var(--info)', 'var(--ok)', 'var(--live)', 'var(--warn)', 'var(--t-party)', 'color-mix(in srgb, var(--info) 55%, var(--ok))', 'var(--t-lunch)']

export function menuColor (item, index) {
  return item.custom_button_color || TILE_COLORS[index % TILE_COLORS.length]
}
